import { formatDateLong } from 'platform/utilities/date';
import { focusElement } from 'platform/utilities/ui';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import PdfDownloadLink from '../PdfDownloadLink';

const ConfirmationScreenView = ({ formConfig, submissionName, timestamp }) => {
  useEffect(() => focusElement('h2', {}, 'va-alert'), []);

  return (
    <>
      <va-alert status="success">
        <h2 slot="headline" className="vads-u-font-size--h3">
          You submitted your application for health benefits
        </h2>
      </va-alert>

      <va-summary-box class="vads-u-margin-y--4">
        <h3 slot="headline">Your submission information</h3>

        <h4>Who submitted this form</h4>
        <p className="dd-privacy-mask" data-dd-action-name="submission name">
          {submissionName}
        </p>

        {timestamp && (
          <>
            <h4>Date submitted</h4>
            <p
              className="dd-privacy-mask"
              data-dd-action-name="submission date"
            >
              {formatDateLong(timestamp)}
            </p>
          </>
        )}

        <h4>Confirmation for your records</h4>
        <p>You can print this confirmation page for your records.</p>

        <div className="vads-u-margin-y--2">
          <va-button
            text="Print this page"
            onClick={() => window.print()}
            data-testid="hca-print-button"
          />
        </div>
        <PdfDownloadLink formConfig={formConfig} />
      </va-summary-box>
    </>
  );
};

ConfirmationScreenView.propTypes = {
  formConfig: PropTypes.object,
  submissionName: PropTypes.string,
  timestamp: PropTypes.number,
};

export default ConfirmationScreenView;
